export default __webpack_public_path__ + "media/images/images/portfolio/portfolio-4-5244f28068c4a9cac5c4ec5f7e5d7b26.jpg";